module.exports = __webpack_public_path__ + "img/yellow.4e8db819.png";